import { getValueFromStorage, removeFromStorage, saveToStorage } from "@/utils/secureStore";
import { useFocusEffect } from "expo-router";
import type { ParkPassRedeemPOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";
import { useCallback, useEffect, useState } from "react";

export interface LastPassRedeem {
  passRedeemResponse: ParkPassRedeemPOSTSuccessResponse;
  termsAndConditionsOKTimestamp: string;
}

export function usePassRedeemStorage(termsAndConditionsOKTimestamp: string) {
  const [alreadyRedeemed, setAlreadyRedeemed] = useState<boolean>(false);
  const [hasLoaded, setHasLoaded] = useState<boolean>(false);
  const [lastPassRedeem, setLastPassRedeem] = useState<LastPassRedeem | null>(null);

  const saveLastPassRedeem = (newLastPassRedeem: LastPassRedeem | null) => {
    if (newLastPassRedeem) {
      saveToStorage("lastPassRedeem", JSON.stringify(newLastPassRedeem));
    } else {
      removeFromStorage("lastPassRedeem");
    }
    setHasLoaded(false);
  };

  useEffect(() => {
    async function fetchData() {
      const storedLastPassRedeem = await getValueFromStorage("lastPassRedeem");

      const storedLastPassRedeemInstace = storedLastPassRedeem ? (JSON.parse(storedLastPassRedeem) as LastPassRedeem) : null;
      setLastPassRedeem(storedLastPassRedeemInstace);
      setAlreadyRedeemed(termsAndConditionsOKTimestamp === storedLastPassRedeemInstace?.termsAndConditionsOKTimestamp);
      setHasLoaded(true);
    }

    if (!hasLoaded) {
      fetchData();
    }
  }, [hasLoaded, termsAndConditionsOKTimestamp]);

  useFocusEffect(useCallback(() => setHasLoaded(false), []));

  return {
    alreadyRedeemed,
    hasLoaded,
    lastPassRedeem,
    saveLastPassRedeem,
  };
}
